import React, { useEffect } from 'react';
import { inject, observer } from 'mobx-react';

import { ShellAuthorizeContextValue, ShellUserRegionContextValue } from '@vtblife/layout-components/shell/contexts';
import { useUserRegion } from '@vtblife/layout-components/shell/hooks/use-user-region';
import { RegionModals } from '@vtblife/layout-components/shell/components/region-modals/region-modals';

import { Navbar } from '@vtblife/layout-components/navbar/navbar';

import { getProfileHeaderByRoleType } from '@vtblife/layout-components/utils';

import { RootStore } from '../../stores/root';
import { Sidebar } from '../../components/side-menu/sidebar';
import { IS_WEBVIEW_CLIENT } from '../../constants';
import styles from './navbar-island.module.css';
import { UpperNavbarAuthorizedMobile } from '../../components/upper-navbar-authorized/upper-navbar-authorized-mobile';

export const NavbarIslandInner = ({ rootStore }: { rootStore: RootStore }) => {
    const { navbarStore, userStore } = rootStore;
    const { user, isAlreadyPassedM2ProVerification, isAuthorized } = userStore;
    const { pathname } = rootStore.historyStore.location;
    const { shouldDisableRegionModals } = rootStore.layoutStore;
    const { profile } = rootStore.userStore;
    const userRegion = useUserRegion();

    const navbarMenuItems = navbarStore.currentMenuItems;

    useEffect(() => {
        const unsubscribe = userRegion.callSubscribe();
        return unsubscribe;
    }, [userRegion.callSubscribe]);

    return (
        <ShellAuthorizeContextValue.Provider
            value={{
                authorize: {
                    user,
                    isAuthorized,
                    verification: { isAlreadyPassedM2ProVerification },
                },
            }}
        >
            <ShellUserRegionContextValue.Provider
                value={{
                    userRegion,
                }}
            >
                <Sidebar className={styles.desktopSidebar} />
                {!IS_WEBVIEW_CLIENT && (
                    <>
                        {pathname === '/personal-area' && (
                            <UpperNavbarAuthorizedMobile
                                description={getProfileHeaderByRoleType(user?.currentRoleType) || undefined}
                                title={profile?.personalData?.fullName?.name}
                            />
                        )}
                        <Navbar menuItems={navbarMenuItems} currentPathname={pathname} />
                    </>
                )}
                {!shouldDisableRegionModals && <RegionModals />}
            </ShellUserRegionContextValue.Provider>
        </ShellAuthorizeContextValue.Provider>
    );
};

export const NavbarIsland = inject('rootStore')(observer(NavbarIslandInner)) as React.FC;
